import React from 'react';
// import scrollToComponent from 'react-scroll-to-component';
import Header from '../header';
import HomeAbout from './homeAbout';
import HomeContact from './homeContact';
import HomeFeaturedEvents from './homeFeaturedEvents';
import HomeOmg from './homeOmg';
import './home.scss'

class Home extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activeLink: 'about',
    };

    this.onLinkClick = this.onLinkClick.bind(this);
  }

  componentDidMount() {
    // get hash
    // if (localStorage.getItem('section')) {
    //   const link = localStorage.getItem('section');
    //   setTimeout(() => {
    //     scrollToComponent(this[link].current, { offset: 0, align: 'top', duration: 500})
    //   }, 100);
    // }
  }

  onLinkClick(e, link) {
    // e.preventDefault();
    // scrollToComponent(this[link].current, { offset: 0, align: 'top', duration: 1500});
    // localStorage.removeItem('section');
  }

  render() {
    const { activeLink } = this.state;

    return (
      <div>
        <Header
          activeLink={activeLink}
        />
        <div className="page-content">
          <HomeAbout />
          <HomeOmg />
          <HomeFeaturedEvents />
          <HomeContact />
        </div>
      </div>
    );
  }
}

export default Home;
